const noun = (value, noun) => `${noun}${value > 1 ? `s` : ``}`;
exports.noun = noun;
